import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { io } from "socket.io-client";

import { chatbot } from "../../components";

const SupportChat = () => {
  const socket = useRef();

  const { support } = useSelector((state) => state.chatbot);
  const profileData = useSelector((state) => state.profile?.user);

  const [activeUser, setActiveUser] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    setCurrentUser(profileData.id);
  }, [profileData]);

  useEffect(() => {
    if (currentUser) {
      socket.current = io(process.env.REACT_APP_BACKEND_URL);
      socket.current.emit("add-user", currentUser);
    }
  }, [currentUser]);

  useEffect(() => {
    setActiveUser(support[0]);
  }, [currentUser]);

  return (
    <div className="h-[calc(100vh-15.625em)]">
      <div>
        {!activeUser ? (
          <chatbot.Welcome />
        ) : (
          <chatbot.ChatContainer currentChat={activeUser} socket={socket} />
        )}
      </div>
    </div>
  );
};

export default SupportChat;
